// extracted by mini-css-extract-plugin
export default {"header":"skills_management_header-module___header___ac42259d","titleRow":"skills_management_header-module___titleRow___e715119c"};